var amt_admin = require('amt_admin').default;
var app = require('angular').module('ww2_analytics.alliance', [amt_admin]);

app.config(['$stateProvider', function($stateProvider) {
  $stateProvider
    .state('amt.ww2.alliance', {
      url: '/alliance',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: 'Alliance',
        role: 'alliance'
      },
      menu: {
        glyphicon: 'text-background',
        childs: [
          {state: 'amt.ww2.alliance.activity', glyphicon: 'text-background'},
        ],
      },
    })
    .state('amt.ww2.alliance.activity', require('./activity').default)
}]);

export default app.name;
